import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import Layout from '../components/layout';
import { LoadingBox } from '../components/loading-box';
import SEO from '../components/seo';
import linesImg from '../images/lines.jpg';

const PageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  height: 100%;
  width: 100%;
`;

const CrtLines = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url(${linesImg});
  z-index: 10;
  background-size: 7px auto;
  mix-blend-mode: color;
  pointer-events: none;
  opacity: 0.2;
  animation: moveDownAnimation 150s linear infinite;

  @keyframes moveDownAnimation {
    100% {
      background-position-y: 100%;
    }
  }
`;

const IndexPage = () => (
  <Layout>
    <SEO title="Lukas Bobinas" />
    <CrtLines />
    <PageContainer>
      <LoadingBox finalTitle="ERROR" />
    </PageContainer>
  </Layout>
);

export default IndexPage;
